var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeTotalProfit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1813_109351)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9712 38.0755C25.4404 36.9387 24.352 35.3055 23.8923 33.455C23.4325 31.6046 23.63 29.6519 24.4508 27.9309C25.2716 26.2099 26.6648 24.8275 28.3921 24.0201C30.1195 23.2128 32.0737 23.0306 33.9205 23.5047L33.9303 23.4815C33.9886 23.3329 34.0008 23.1701 33.9654 23.0143C33.93 22.8586 33.8486 22.7171 33.7317 22.6083L26.0452 15.4461C25.8978 15.3088 25.7039 15.2324 25.5024 15.2324C25.301 15.2324 25.107 15.3088 24.9596 15.4461L17.2801 22.6084C17.1637 22.7176 17.0827 22.8592 17.0477 23.0149C17.0127 23.1706 17.0253 23.3333 17.0838 23.4818C17.1423 23.6302 17.244 23.7578 17.3758 23.8478C17.5076 23.9378 17.6634 23.9861 17.823 23.9866H19.4052V39.971C19.4052 40.1822 19.4891 40.3847 19.6384 40.534C19.7877 40.6833 19.9902 40.7672 20.2014 40.7672H23.0648V38.6487C23.0647 38.5081 23.1205 38.3732 23.2199 38.2737C23.3193 38.1742 23.4541 38.1182 23.5947 38.1181L26.9567 38.1135L26.9712 38.0755Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1505 39.0403H38.6134V40.0589C38.6111 40.2262 38.5425 40.3858 38.4226 40.5025C38.3027 40.6192 38.1414 40.6835 37.9741 40.6813H24.7893C24.622 40.6836 24.4606 40.6193 24.3407 40.5025C24.2207 40.3858 24.1521 40.2262 24.1498 40.0589L24.1505 39.0403Z",
    fill: "#1D1B18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1226 38.3067C35.905 38.3067 38.9712 35.2405 38.9712 31.4581C38.9712 27.6758 35.905 24.6096 32.1226 24.6096C28.3403 24.6096 25.2741 27.6758 25.2741 31.4581C25.2741 35.2405 28.3403 38.3067 32.1226 38.3067ZM32.2483 26.8627C32.48 26.8627 32.6634 27.0934 32.6634 27.3251V27.943H34.0219C34.2536 27.943 34.5102 28.1217 34.5102 28.3742V28.5286C34.5102 28.7604 34.2854 28.9472 34.0537 28.9472H31.0413C30.8096 28.9472 30.5778 29.1016 30.4234 29.2561C30.1916 29.4879 30.1144 29.7196 30.1144 29.9513C30.1144 30.183 30.2689 30.4148 30.4234 30.5692C30.5778 30.7237 30.8096 30.8782 31.0413 30.8782H33.1268C33.6675 30.8782 34.1804 31.0695 34.5944 31.4961C34.9655 31.8785 35.2123 32.3458 35.2123 32.8865C35.2123 33.4272 35.0578 33.8906 34.7489 34.2768C34.4399 34.663 33.8992 34.8947 33.3585 34.8947H32.8178V35.5899C32.8178 35.8216 32.5861 36.0534 32.3544 36.0534H32.1227C31.8909 36.0534 31.6592 35.8216 31.6592 35.5899V34.8947H29.9599C29.7282 34.8947 29.4965 34.663 29.4965 34.4313V34.1996C29.4965 33.9679 29.6509 33.8134 29.8827 33.8134H33.1268C33.5203 33.8134 33.756 33.6504 33.8888 33.4966C34.0215 33.3429 34.1309 33.1182 34.1309 32.8865C34.1309 32.5962 33.9631 32.3354 33.8404 32.2381L33.8362 32.2348C33.7126 32.1368 33.4892 31.9596 33.1268 31.9596H31.0413C30.5778 31.9596 30.0372 31.7279 29.6509 31.3416C29.2647 31.0327 29.033 30.492 29.033 29.9513C29.033 29.4106 29.303 28.9076 29.6509 28.561C30.025 28.1883 30.5006 27.943 31.0413 27.943H31.582V27.3251C31.582 27.0934 31.7848 26.8627 32.0166 26.8627H32.2483Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1813_109351",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTotalProfit);
export default __webpack_public_path__ + "static/media/Home_Total_Profit.3e6e8cb273359517909f51d7b8f5a413.svg";
export { ForwardRef as ReactComponent };